const DELAY = 100;
let timeOuts = {};
let lastEvent = undefined;
let hoverEntered = false;
export function aTrack(eventName, options, behaviour = {}) {
    try {
        const now = new Date().getTime();
        const previous = timeOuts[eventName];
        timeOuts[eventName] = now;
        if (previous && now - previous < DELAY) {
            return;
        }
        if (behaviour.isHover) {
            // to be accepted, previous must be a 'start', this one must be a 'start',
            // and previous has started at least 2 secs before
            const valid = lastEvent === eventName &&
                hoverEntered &&
                behaviour.step === 'end' &&
                now - previous >= 2000;
            lastEvent = eventName;
            hoverEntered = behaviour.step === 'start';
            if (!valid) {
                // might be a start, and we'll see later
                return;
            } // else continue
        }
        lastEvent = eventName;
        if (behaviour.isDebounced) {
            setTimeout(() => {
                if (timeOuts[eventName] <= now) {
                    doTrack(eventName, options);
                }
            }, 5000);
        }
        else {
            doTrack(eventName, options);
        }
    }
    catch (e) {
        console.error('error with events', e);
        try {
            doTrack('error-with-events', {
                message: e ? e.message : 'unknown',
                error: e ? JSON.stringify(e).slice(0, 500) : 'unknown',
            });
        }
        catch (e) { }
    }
}
function doTrack(eventName, options) {
    const domain = document.location.hostname;
    const environment = {
        environment: 'staging',
    };
    if (domain.includes('beta.swaap.finance')) {
        environment.environment = 'prod';
    }
    return analytics.track(eventName, Object.assign(Object.assign({}, options), environment), { context: { ip: '0.0.0.0' } });
}
//# sourceMappingURL=a-track.js.map